import moment from "moment";
import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'categorized_messages';

export default {
  state: {
    // Messages are grouped by category ID
    categories: {}
  },

  mutations: {
    setMessagesForCategoryId(state, { categoryId, messages }) {
      state.categories[categoryId] = messages;
    },

    removeMessageFromCategory(state, { categoryId, message }) {
      state.categories[categoryId] = _.reject(state.categories[categoryId], (m) => {
        return m.id === message.id;
      });
    }
  },

  actions: {
    fetchCategorizedMessages({ commit }, categoryId) {
      const params = {
        team_id: auth.teamId(),
        category_id: categoryId,
        per_page: 500, // TODO: handle pagination better
        page: 1
      };

      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params })
        .then((resp) => {
          let messages = _.map(resp.data.data, (msg) => msg.attributes);
          messages = _.sortBy(messages, (message) => {
            return moment(message.created_at).unix();
          });
          commit("setMessagesForCategoryId", { categoryId, messages });
        });
    },

    deleteCategorizedMessage({ commit }, { messageId, categoryId }) {
      return api
        .instance()
        .delete(`${apiVersion}/${source}/${messageId}`, { params: { team_id: auth.teamId(), category_id: categoryId } })
        .then((resp) => {
          commit("removeMessageFromCategory", { categoryId, message: resp.data.data.attributes });
        });
    }
  },

  getters: {
    messagesForCategory(state) {
      return (id) => {
        const messages = state.categories[id];
        return _.isArray(messages) ? messages : [];
      };
    }
  }
};
